import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { BmAnalyticsData, BudgetModel, BudgetModelWrapperDTO } from "../../pojo/bm-classes";
import { BmGeneralService } from "../general/bm-general-service";
import { UrlService } from "../../../../../../environments/urlService";
import { LocalDate } from "../../../../../core/component/pojo/date-variable";

@Injectable({
  providedIn: 'root',
})
export class BudgetModelBackendService {
  private http = inject(HttpClient);
  private urlService = inject(UrlService);

  private readonly url: string;

  constructor() {
    this.url = this.urlService.getModelsUrl() + 'budget-model';
  }

  get(modelUuid: string): Observable<BudgetModel> {
    return this.http.get<BudgetModel>(this.url + '/' + modelUuid, {
      withCredentials: true,
    });
  }

  getInitialModelData(orgUuid: string): Observable<BudgetModelWrapperDTO> {
    return this.http
      .get<BudgetModelWrapperDTO>(this.url + '/initial/' + orgUuid, {
      withCredentials: true,
    })
      .pipe(
        map((wrapper) => ({
          ...wrapper,
          selectorData: wrapper.selectorData.map((modelMiniData) => ({
            ...modelMiniData,
            selectorText: BmGeneralService.createSelectorText(modelMiniData),
          })),
        })),
      );
  }

  getAnalyticsData(fundUuid: string, selectedPeriod: LocalDate): Observable<BmAnalyticsData> {
    return this.http
      .get<BmAnalyticsData>(this.url + '/analytics/' + fundUuid + '/' + selectedPeriod, {
      withCredentials: true,
    });
  }

  create(model: BudgetModel): Observable<BudgetModel> {
    return this.http.post<BudgetModel>(this.url, model, {
      withCredentials: true,
    });
  }

  update(model: BudgetModel): Observable<BudgetModel> {
    return this.http.put<BudgetModel>(this.url, model, {
      withCredentials: true,
    });
  }

  duplicate(modelUuid: string): Observable<BudgetModel> {
    return this.http.post<BudgetModel>(
      this.url + '/duplicate/' + modelUuid, null,
      { withCredentials: true },
    );
  }

  delete(modelUuid: string): Observable<void> {
    return this.http.delete<void>(this.url + '/' + modelUuid, {
      withCredentials: true,
    });
  }
}
